"use strict";

import Vue from "vue";
import axios from "axios";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.defaults.timeout = 30000; // ms
axios.defaults.retry = 4; // count
axios.defaults.retryDelay = 1000; // ms

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};
const _axios = axios.create(config);
const token = localStorage.getItem("authorization") || "";

_axios.interceptors.request.use(
  function(config) {
    if (window.location.href.indexOf("stage-reuters.carrotenglish.net") > -1) {
      // 스테이지
      config.baseURL = "https://stage-reuters-api.carrotenglish.net";
    } else if (window.location.href.indexOf("localhost") > -1) {
      // 로컬
      config.baseURL = "https://stage-reuters-api.carrotenglish.net";
    } else if (window.location.href.indexOf("reuters.carrotenglish.com") > -1) {
      // 운영
      config.baseURL =
        window.location.protocol + "//reuters-api.carrotenglish.com";
    }

    config.headers.authorization = token;
    config.headers.post["Content-Type"] = "application/json";
    config.headers.put["Content-Type"] = "application/json";
    config.withCredentials = false;

    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    console.log("Network Error, Retry");
    var config = error.config;

    // If config does not exist or the retry option is not set, reject
    if (!config || !config.retry) {
      console.log("config.retry Not Exist");
      return Promise.reject(error);
    }

    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;

    // Check if we've maxed out the total number of retries
    if (config.__retryCount >= config.retry) {
      // Reject with the error
      console.log("Retry Count Overflow");
      return Promise.reject(error);
    }

    // Increase the retry count
    config.__retryCount += 1;

    // Create new promise to handle exponential backoff
    var backoff = new Promise(function(resolve) {
      console.log("Create New Promise");
      setTimeout(function() {
        resolve();
      }, config.retryDelay);
    });

    // Return the promise in which recalls axios to retry the request
    return backoff.then(function() {
      console.log("Recalls Axios to Retry");
      return _axios(config);
    });
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;



// WEBPACK FOOTER //
// ./src/plugins/axios.js